import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import ActionTypes from '../../constants/ActionTypes';
export var INITIAL_STATE = {
  key: null
};
/**
 * @param state
 * @param action
 * @param action.key {string}
 * @return {Object}
 */

var setKey = function setKey(state, action) {
  return _objectSpread(_objectSpread({}, state), {}, {
    key: action.key
  });
};

var setBaseUrl = function setBaseUrl(state, action) {
  return _objectSpread(_objectSpread({}, state), {}, {
    baseUrl: action.url
  });
};

var setLocalConfiguration = function setLocalConfiguration(state, action) {
  var path = action.path.split('.');
  return _objectSpread(_objectSpread({}, state), {}, {
    localConfiguration: setHelper(state.localConfiguration, path, action.value)
  });
};

var updateLocalConfiguration = function updateLocalConfiguration(state, action) {
  return _objectSpread(_objectSpread({}, state), {}, {
    localConfiguration: state.localConfiguration ? _objectSpread(_objectSpread({}, state.localConfiguration), action.update) : action.update
  });
};

function setHelper(state, path, value) {
  var remainingPath = _toConsumableArray(path);

  var currentKey = remainingPath.shift();

  if (remainingPath.length) {
    return _objectSpread(_objectSpread({}, state), {}, _defineProperty({}, currentKey, setHelper(state[currentKey], remainingPath, value)));
  } else {
    return _objectSpread(_objectSpread({}, state), {}, _defineProperty({}, currentKey, value));
  }
}

var receiveConfiguration = function receiveConfiguration(state, action) {
  return _objectSpread(_objectSpread({}, state), {}, {
    configuration: action.configuration
  });
};

export default (function () {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : INITIAL_STATE;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case ActionTypes.APP.SET_BASE_URL:
      return setBaseUrl(state, action);

    case ActionTypes.APP.SET_KEY:
      return setKey(state, action);

    case ActionTypes.APP.SET_LOCAL_CONFIGURATION:
      return setLocalConfiguration(state, action);

    case ActionTypes.APP.UPDATE_LOCAL_CONFIGURATION:
      return updateLocalConfiguration(state, action);

    case ActionTypes.APP.RECEIVE_CONFIGURATION:
      return receiveConfiguration(state, action);

    default:
      return state;
  }
});